import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import ImpressumPage from './pages/ImpressumPage';
import './App.css'; // Optional: for global styles

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="content"> {/* Added a main container */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projekte" element={<ProjectsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            {/* Add a 404 Not Found route if desired */}
            {/* <Route path="*" element={<div>404 Not Found</div>} /> */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;